import { arrayResultMemoizeOptions } from 'checkout/lib/utils/misc/arrayResultMemoizeOptions'
import createSelector from 'lib/createSelector'
import { isOfferValidWithRegion } from 'lib/recentlyViewedOffers'

export const getRecentlyViewedOfferIds = createSelector(
  (state: App.State) => state.offer.recentlyViewed.offers,
  (recentlyViewedOffers: App.RecentlyViewedOffer[]) => {
    return recentlyViewedOffers.map(offer => offer.offerId)
  },
  arrayResultMemoizeOptions,
)

export const getRecentlyViewedOffers = createSelector(
  getRecentlyViewedOfferIds,
  (state: App.State) => state.offer.offerSummaries,
  (state: App.State) => state.offer.offers,
  (state: App.State) => state.geo.currentRegionCode,
  (ids, summaries, offers, currentRegionCode) => {
    return ids.map(id => offers[id] ?? summaries[id])
      .filter((offer) => Boolean(offer) && isOfferValidWithRegion(offer, currentRegionCode))
  },
)

export const isRecentlyViewedOffersLoading = createSelector(
  getRecentlyViewedOfferIds,
  (state: App.State) => state.offer.recentlyViewed.state,
  (state: App.State) => state.offer.offersLoading,
  (state: App.State) => state.offer.offerSummariesLoading,
  (ids, idsLoadingState, offersLoading, offerSummariesLoading) => {
    const idsLoading = idsLoadingState !== 'done'
    return idsLoading || ids.some(id => !!offersLoading[id] || !!offerSummariesLoading[id])
  },
)
